const locale = {
	project_code: 'Project Code :',
	branch: 'Branch :',
};

export default locale;
